module.exports = __webpack_public_path__ + "media/images/photo/plans/places/daisan_bridge-b4a1d6a37aefa9354081d4bec3b0c917.png";